import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const HashTagIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4182 7.58172 20 12 20C16.4182 20 20 16.4182 20 12C20 7.58172 16.4182 4 12 4ZM11.1698 7.5222C11.7098 7.63792 12.0538 8.1695 11.9381 8.70953L11.7942 9.38103H13.0661L13.2998 8.29047C13.4155 7.75045 13.9471 7.40648 14.4871 7.5222C15.0271 7.63792 15.3711 8.1695 15.2554 8.70953L15.1115 9.38103H15.5C16.0523 9.38103 16.5 9.82875 16.5 10.381C16.5 10.9333 16.0523 11.381 15.5 11.381H14.6829L14.4176 12.619H15.5C16.0523 12.619 16.5 13.0667 16.5 13.619C16.5 14.1713 16.0523 14.619 15.5 14.619H13.989L13.7554 15.7095C13.6396 16.2496 13.108 16.5935 12.568 16.4778C12.028 16.3621 11.684 15.8305 11.7998 15.2905L11.9436 14.619H10.6718L10.4381 15.7095C10.3224 16.2496 9.79079 16.5935 9.25076 16.4778C8.71074 16.3621 8.36677 15.8305 8.48249 15.2905L8.62638 14.619H8.5C7.94772 14.619 7.5 14.1713 7.5 13.619C7.5 13.0667 7.94772 12.619 8.5 12.619H9.05496L9.32023 11.381H8.5C7.94772 11.381 7.5 10.9333 7.5 10.381C7.5 9.82875 7.94772 9.38103 8.5 9.38103H9.7488L9.98249 8.29047C10.0982 7.75045 10.6298 7.40648 11.1698 7.5222ZM11.3656 11.381L11.1004 12.619H12.3722L12.6375 11.381H11.3656Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

HashTagIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(HashTagIcon);
